"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateFilterFields = exports.UrlsSchema = exports.UrlSchema = exports.CountSchema = exports.castToCountry = exports.supportedCountries = exports.CountrySchema = exports.WeightingSchema = exports.UnderOrOverPercentageSchema = exports.OverPercentageSchema = exports.PercentageSchema = exports.MoneySchema = exports.VersionNumberSchema = exports.castToCurrency = exports.supportedCurrencies = exports.CurrencySchema = exports.EnabledSchema = exports.PasswordSchema = exports.EmailSchema = exports.DescriptionSchema = exports.NameSchema = exports.SELECT_ID = void 0;
const typebox_1 = require("@sinclair/typebox");
const cast_1 = require("../utils/cast");
const primitives_1 = require("./primitives");
const time_1 = require("./time");
/**
 * Helper for prisma to select only the id
 */
exports.SELECT_ID = { id: true };
exports.NameSchema = typebox_1.Type.String({
    minLength: 1,
    maxLength: 256,
    title: "Name",
    description: "Short friendly name",
    examples: ["Example"],
});
exports.DescriptionSchema = typebox_1.Type.String({
    minLength: 0,
    maxLength: 1024,
    title: "Description",
    description: "Longer description of the item",
    examples: ["A longer example"],
});
exports.EmailSchema = typebox_1.Type.String({
    format: "email",
    examples: ["user@example.com"],
    title: "Email",
    description: "Email address",
    maxLength: 256,
});
exports.PasswordSchema = typebox_1.Type.String({
    title: "Password",
    description: "Password",
    minLength: 6,
    maxLength: 256,
    examples: ["C0mpl3x!"],
});
exports.EnabledSchema = typebox_1.Type.Boolean({
    title: "Enabled",
    description: "Is the item enabled / able to be used?",
    examples: [true],
});
exports.CurrencySchema = (0, primitives_1.StringUnion)(["AUD", "CAD", "EUR", "GBP", "JPY", "MXN", "NZD", "CNY", "RUB", "USD"], {
    title: "Currency",
    description: "The currency of monetary amount",
});
exports.supportedCurrencies = exports.CurrencySchema.examples;
exports.castToCurrency = (0, cast_1.castToValues)(exports.CurrencySchema.examples);
exports.VersionNumberSchema = typebox_1.Type.Integer({
    default: 1,
    title: "Version",
    description: "Version number",
    examples: [1, 2, 5],
});
exports.MoneySchema = typebox_1.Type.Number({
    minimum: 0,
    // Though money should be a multiple of this, we don't control JS floating point view (e.g. 1 is not a mulitple of 0.01)
    // multipleOf: 0.01,
    // Sensible to have a max, but unclear what should be
    maximum: 100000000,
    title: "Money",
    description: "Monetary value (currency free, see Currency)",
    examples: [0, 1.23, 4.56],
});
exports.PercentageSchema = typebox_1.Type.Number({
    minimum: 0,
    maximum: 100,
    title: "Percentage",
    description: "Percentage up to 100%",
    examples: [0, 50, 75],
});
exports.OverPercentageSchema = typebox_1.Type.Number({
    minimum: 100,
    maximum: 1000,
    title: "Percentage",
    description: "Percentage in excess of 100%",
    examples: [100, 150, 200],
});
exports.UnderOrOverPercentageSchema = typebox_1.Type.Number({
    minimum: 0,
    maximum: 1000,
    title: "Percentage",
    description: "Percentage between 0 and 1000%",
    examples: [50, 100, 150, 200],
});
exports.WeightingSchema = typebox_1.Type.Number({
    // Really the max and multiple doesn't matter, but validation is always good.
    minimum: 0,
    maximum: 10000000,
    examples: [1, 2, 10],
});
exports.CountrySchema = (0, primitives_1.StringUnion)(
// This is the full list:
[
    "AD",
    "AE",
    "AF",
    "AG",
    "AI",
    "AL",
    "AM",
    "AO",
    "AQ",
    "AR",
    "AS",
    "AT",
    "AU",
    "AW",
    "AX",
    "AZ",
    "BA",
    "BB",
    "BD",
    "BE",
    "BF",
    "BG",
    "BH",
    "BI",
    "BJ",
    "BL",
    "BM",
    "BN",
    "BO",
    "BQ",
    "BR",
    "BS",
    "BT",
    "BV",
    "BW",
    "BY",
    "BZ",
    "CA",
    "CC",
    "CD",
    "CF",
    "CG",
    "CH",
    "CI",
    "CK",
    "CL",
    "CM",
    "CN",
    "CO",
    "CR",
    "CU",
    "CV",
    "CW",
    "CX",
    "CY",
    "CZ",
    "DE",
    "DJ",
    "DK",
    "DM",
    "DO",
    "DZ",
    "EC",
    "EE",
    "EG",
    "EH",
    "ER",
    "ES",
    "ET",
    "FI",
    "FJ",
    "FK",
    "FM",
    "FO",
    "FR",
    "GA",
    "GB",
    "GD",
    "GE",
    "GF",
    "GG",
    "GH",
    "GI",
    "GL",
    "GM",
    "GN",
    "GP",
    "GQ",
    "GR",
    "GS",
    "GT",
    "GU",
    "GW",
    "GY",
    "HK",
    "HM",
    "HN",
    "HR",
    "HT",
    "HU",
    "ID",
    "IE",
    "IL",
    "IM",
    "IN",
    "IO",
    "IQ",
    "IR",
    "IS",
    "IT",
    "JE",
    "JM",
    "JO",
    "JP",
    "KE",
    "KG",
    "KH",
    "KI",
    "KM",
    "KN",
    "KP",
    "KR",
    "KW",
    "KY",
    "KZ",
    "LA",
    "LB",
    "LC",
    "LI",
    "LK",
    "LR",
    "LS",
    "LT",
    "LU",
    "LV",
    "LY",
    "MA",
    "MC",
    "MD",
    "ME",
    "MF",
    "MG",
    "MH",
    "MK",
    "ML",
    "MM",
    "MN",
    "MO",
    "MP",
    "MQ",
    "MR",
    "MS",
    "MT",
    "MU",
    "MV",
    "MW",
    "MX",
    "MY",
    "MZ",
    "NA",
    "NC",
    "NE",
    "NF",
    "NG",
    "NI",
    "NL",
    "NO",
    "NP",
    "NR",
    "NU",
    "NZ",
    "OM",
    "PA",
    "PE",
    "PF",
    "PG",
    "PH",
    "PK",
    "PL",
    "PM",
    "PN",
    "PR",
    "PS",
    "PT",
    "PW",
    "PY",
    "QA",
    "RE",
    "RO",
    "RS",
    "RU",
    "RW",
    "SA",
    "SB",
    "SC",
    "SD",
    "SE",
    "SG",
    "SH",
    "SI",
    "SJ",
    "SK",
    "SL",
    "SM",
    "SN",
    "SO",
    "SR",
    "SS",
    "ST",
    "SV",
    "SX",
    "SY",
    "SZ",
    "TC",
    "TD",
    "TF",
    "TG",
    "TH",
    "TJ",
    "TK",
    "TL",
    "TM",
    "TN",
    "TO",
    "TR",
    "TT",
    "TV",
    "TW",
    "TZ",
    "UA",
    "UG",
    "UM",
    "US",
    "UY",
    "UZ",
    "VA",
    "VC",
    "VE",
    "VG",
    "VI",
    "VN",
    "VU",
    "WF",
    "WS",
    "YE",
    "YT",
    "ZA",
    "ZM",
    "ZW",
], 
// Apple supported regions
// [
// "AE",
// "AL",
// "AM",
// "AR",
// "AT",
// "AU",
// "AZ",
// "BE",
// "BG",
// "BH",
// "BO",
// "BR",
// "CA",
// "CH",
// "CL",
// "CN",
// "CO",
// "CR",
// "CY",
// "CZ",
// "DE",
// "DK",
// "DO",
// "DZ",
// "EC",
// "EG",
// "EE",
// "ES",
// "SV",
// "FI",
// "FR",
// "GB",
// "GH",
// "GR",
// "GT",
// "HK",
// "HN",
// "HR",
// "HU",
// "ID",
// "IE",
// "IL",
// "IN",
// "IQ",
// "IS",
// "IT",
// "JP",
// "JO",
// "KE",
// "KH",
// "KG",
// "KZ",
// "KR",
// "KW",
// "LB",
// "LK",
// "LU",
// "LV",
// "MA",
// "MN",
// "MO",
// "MX",
// "MY",
// "NL",
// "NO",
// "NP",
// "NZ",
// "OM",
// "PA",
// "PE",
// "PH",
// "PK",
// "PL",
// "PT",
// "PY",
// "QA",
// "RO",
// "RU",
// "SA",
// "SE",
// "SG",
// "SI",
// "SK",
// "TH",
// "TR",
// "TW",
// "UA",
// "US",
// "UZ",
// "VN",
// "ZA",
// ],
{
    title: "Country",
    description: "Country code",
});
exports.supportedCountries = exports.CountrySchema.examples;
exports.castToCountry = (0, cast_1.castToValues)(exports.CountrySchema.examples);
exports.CountSchema = typebox_1.Type.Number({
    minimum: 0,
});
exports.UrlSchema = typebox_1.Type.String({ format: "url" });
exports.UrlsSchema = typebox_1.Type.Array(exports.UrlSchema);
exports.DateFilterFields = {
    to: typebox_1.Type.Optional(time_1.TimestampSchema),
    from: typebox_1.Type.Optional(time_1.TimestampSchema),
};
